import { onSuccess } from "../../utils/helper";
import { UPDATE_UPLOAD_PERCENTAGE,
    RESET_UPLOAD_PERCENTAGE } from "../common/constants";

export const updateUploadingRequest = (type, percentage) => (onSuccess(UPDATE_UPLOAD_PERCENTAGE, { type, percentage }));

export const resetUploadingRequest = () => onSuccess(RESET_UPLOAD_PERCENTAGE)